export interface TrashEntry {
  id: string;
  dateTime: string;
  positionRemarks: string;
  category: string;
  estimatedAmount: string;
  toSea: boolean;
  toReceptionFacility: boolean;
  incineration: boolean;
  certificationSignature: string;
}

export interface TrashLogState {
  date: string;
  entries: TrashEntry[];
}

export interface GarbageCategory {
  code: string;
  label: string;
}

// MARPOL Annex V garbage categories (A–I).
export const GARBAGE_CATEGORIES: GarbageCategory[] = [
  { code: 'A', label: 'Plastics' },
  { code: 'B', label: 'Food wastes' },
  { code: 'C', label: 'Domestic wastes' },
  { code: 'D', label: 'Cooking oil' },
  { code: 'E', label: 'Incinerator ashes' },
  { code: 'F', label: 'Operational waste' },
  { code: 'G', label: 'Animal carcass(es)' },
  { code: 'H', label: 'Fishing gear' },
  { code: 'I', label: 'E-waste' },
];

export const CARGO_RESIDUES_NOTE =
  "The term 'cargo residues' is not officially defined within current regulations. " +
  'The officer responsible must ensure that disposal of garbage within this category is legal.';
